import { ProgressBarsHeader } from './ProgressBarsHeader';

interface IProgressBarsLayoutProps {
  className: string;
  onCreateNew: () => void;
  isCreateHidden: boolean;
  children: React.ReactNode;
}

export const ProgressBarsLayout = ({
  className,
  onCreateNew,
  isCreateHidden,
  children
}: IProgressBarsLayoutProps): React.ReactElement => {
  return (
    <div className={className}>
      <ProgressBarsHeader
        onCreateNew={onCreateNew}
        isCreateHidden={isCreateHidden}
      />
      {children}
    </div>
  );
};
